import InfoMainAddress from "./InfoMainAddress"
import InfoPastAddresses from "./InfoPastAddresses"
import { SpaceModel } from "../../interfaces/Space";


type Props = {
    space: SpaceModel | undefined,
    open: boolean,
    imageSource: string,
    mapsUrl: string
}

export default function InfoAddress({ space, imageSource, mapsUrl }: Props) {

    return <div>
        <div className="info-address-container">
            <div className="infobar-section infobar-address">
                {space && <InfoMainAddress space={space} />}
            </div>
            <div
                className={`info-address-image-container`}
                onClick={() => {
                    window.open(mapsUrl)
                }} >
                <div className={imageSource ? '' : 'info-address-loading-image'}>
                    {imageSource && <img src={imageSource} alt=""></img>}
                </div>
            </div>
        </div>
        {space && space.oldAddresses && space.oldAddresses.length > 0 && <div className="infobar-section infobar-old-address">
            <div>Moradas anteriores:</div>
            <InfoPastAddresses space={space} />
        </div>}
    </div>
}